import { RightOutlined } from '@ant-design/icons';
import { Input, Modal } from 'antd';
import VirtualList from 'rc-virtual-list';
import { useCallback, useMemo, useState } from 'react';

import { useExtranetHotelsList } from 'app/hooks/data/core/extranet/hotel/useHotelsList';

const { Search } = Input;

type SearchHotelModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (hotelId: number) => void;
};

export const SearchHotelModal = ({
  isOpen,
  onClose,
  onSelect,
}: SearchHotelModalProps) => {
  const { data: hotelsList } = useExtranetHotelsList();
  const [searchText, setSearchText] = useState('');

  const sortedHotels = useMemo(() => {
    return hotelsList?.sort((a, b) =>
      a.name.trim().localeCompare(b.name.trim())
    );
  }, [hotelsList]);

  const internalSelect = useCallback(
    (hotelId: number) => {
      setSearchText('');
      onSelect(hotelId);
    },
    [onSelect, setSearchText]
  );

  const internalCancel = useCallback(() => {
    setSearchText('');
    onClose();
  }, [onClose, setSearchText]);

  const match = searchText.toLowerCase();

  const filteredHotels = sortedHotels?.filter((hotel) =>
    hotel.name.toLowerCase().includes(match)
  );

  return (
    <Modal
      className="sider-hotel-popup"
      open={isOpen}
      title={
        <Search
          placeholder="Search..."
          style={{ width: '512px' }}
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
        />
      }
      onCancel={internalCancel}
      footer={null}
      width={600}
    >
      <VirtualList
        data={filteredHotels ?? []}
        itemKey={(hotel) => hotel.id.toString()}
        itemHeight={48}
        height={333}
      >
        {(hotel) => (
          <div
            className="popup-section"
            key={hotel.id}
            onClick={() => internalSelect(hotel.id)}
          >
            <div className="section-text">{hotel.name}</div>
            <div className="section-icon">
              <RightOutlined />
            </div>
          </div>
        )}
      </VirtualList>
    </Modal>
  );
};
